export default __webpack_public_path__ + "static/media/acorn.52db078c.svg";